import React from "react";

export const ContactFormTitle = () => {
  return (
    <>
      <div className="contactFormTitle">
        <h2>Contáctate con nosotros</h2>
        <p>Déjanos tus datos para poder responderte a la brevedad</p>
      </div>
    </>
  );
};
